<template>
    <div class="container mx-auto p-5">
        <div v-if="!isLoading">
            <div class="mt-4">
                <input type="text" class="form-control" placeholder="Username or Email address" v-model="username" >    
            </div>
            <div class="mt-4">    
            <input type="password" class="form-control" placeholder="Username or Email address" v-model="password" >
            </div>
            <div class="mt-4 px-4">
                <input type="checkbox" id="rememberMe" class="" placeholder="Username or Email address" v-model="rememberMe" >
                <label for="rememberMe"> Remember Me</label>
            </div>
            <div class="mt-4">
                <button class="bg-blue-100 text-white p-2 mt-2 w-full rounded-xl" @click="onLogin" v-if="!isLoggedIn"> Login </button>
                <button class="bg-red-100 text-white p-2 mt-2 w-full rounded-xl" @click="onLogout" v-else> Logout </button>

            </div>
            <div class="bg-red-100  rounded-2xl p-4 mt-5" v-if="error">
                <p class="text-white">{{error}}</p>
            </div>
        </div>
        <div v-else>
            <loading v-model:active="isLoading"
                :can-cancel="true"
                :is-full-page="true"/>
        </div>
    </div>
</template>
<script>
import { ref, computed} from 'vue'
import { useStore } from 'vuex'
import Loading from 'vue-loading-overlay';
import { useRouter } from 'vue-router';
import 'vue-loading-overlay/dist/vue-loading.css';
import { VivaAccount } from '@/api/credentials.js'

export default {
    components:{
        Loading,
    },
    setup() {
        const rememberMe = ref(false),
            password = ref(VivaAccount.password),
            username = ref(),
            store = useStore(),
            router = useRouter();
        
        const isLoggedIn = computed(() => {
            return store.getters.isLoggedin 
        })

        const onLogin = async ( ) =>{
            // const params = { plan: 'vfn' , continue : true } 
            await store.dispatch('onLogin', { rememberMe:  rememberMe.value , password: password.value, username: username.value  })
    
            if( (store.state.Login.data.type == 'SUCCESS' || store.state.Login.data.type == 'WARNING' ) && store.state.Login.data.action == 'CONTINUE'){
                // await store.dispatch('checkAccount')
                // await store.dispatch('getSubscription', params )
                router.push({ name : 'HomeVivaPlus' })
            }
        }
        
        const onReload = () => {
            const url = window.location.href
            const slash = url.substr( url.length - 1 )
            if( slash === '/' ){
                window.location.href =  url.slice(0,-1)
            } else {
                window.location.href = url
            }  
        }

        const onLogout = async ( ) => {
            await store.dispatch('onLogout')
            onReload();
        }

        const error = computed(() => {
            return store.state.Login.error
        })

        const isLoading = computed(() => {
            return store.state.Login.loading || store.state.Checkout.loading.subscription || store.state.Accounts.loading
        })

        return {
            rememberMe,
            password,
            username,
            onLogin,
            onLogout,
            error,
            isLoading,
            isLoggedIn
        }
    },
}
</script>